import React, { useState } from "react";
import { Settings_icon } from "../../../icons/settings";
import { Fav_icon } from "../../../icons/fav";
import { Archive } from "../../../icons/archive";
import { left_arrow } from "../../../icons/left_arrow";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Notifications_icon from "../../../icons/notifications";
import Donation_icon from "../../../icons/donations";
import Invoices_icon from "../../../icons/invoices";
import Sales_Icon from "../../../icons/sales";
import Messages_icon from "../../../icons/messages";
import Orders_icon from "../../../icons/orders";


function MobileNav() {
  const elements = [
    {
      icon: Archive,
      title: "مدخلاتي",
      desc: "العروض و الطلبات بالأضافة للخدمات الخاصة بي",
    },
    {
      icon: Fav_icon,
      title: "المفضلة",
      desc: "قائمة بالمحاصيل أو الخدمات التي تم تفضيلها",
    },
    {
      icon: Settings_icon,
      title: "الإعدادات",
      desc: "التفاصيل الخاصة بالحساب",
    },
    {
      icon: Notifications_icon,
      title: "الإشعارات",
      desc: "عرض الإشعارات والتنبيهات",
    },
    {
      icon: Messages_icon,
      title: "الرسائل",
      desc: "الرسائل الواردة والصادرة",
    },
    {
      icon: Orders_icon,
      title: "المشتريات",
      desc: "عرض وتتبع الطلبات",
    },
    {
      icon: Sales_Icon,
      title: "المبيعات",
      desc: "عرض وتتبع المبيعات",
    },
    {
      icon: Invoices_icon,
      title: "الفواتير",
      desc: "عرض وتتبع الفواتير",
    },
    {
      icon: Donation_icon,
      title: "التبرع",
      desc: "التبرعات والمساهمات",
    },
    
  ];
  const navigate = useNavigate();
  const [page, setPage] = useState("");
  const [open, setOpen] = useState(
    window.location.pathname === "/home/profile" ? true : false
  );
  const handleClick = (e) => {
    if (e.title === "مدخلاتي") {
      setPage("inputs");
    } else if (e.title === "الإعدادات") {
      setPage("settings");
    } else if (e.title === "الرسائل") {
      navigate("/home/profile/negotiations");
      setOpen(false);
    } else if (e.title === "المشتريات") {
      navigate("/home/profile/my-orders");
      setOpen(false);
    } else if (e.title === "المبيعات") {
      navigate("/home/profile/my-sales");
      setOpen(false);
    } else if (e.title === "الفواتير") {
      navigate("/home/profile/invoices");
      setOpen(false);
    } else if (e.title === "التبرع") {
      navigate("/home/profile/donations");
      setOpen(false);
    } else if (e.title === "الإشعارات") {
      navigate("/home/profile/notifications");
      setOpen(false);
    } else {
      navigate("/home/profile/fav");
      setOpen(false);
    }
  };
  // const handleClick = (e) =>
  //   e.title === "مدخلاتي"
  //     ? setPage("inputs")
  //     : e.title === "الإعدادات"
  //       ? setPage("settings")
  //       : (navigate("/home/profile/fav"), setOpen(false));
  return (
    <div className="">
      <div className="my-4 w-full text-center relative h-[20px] font-bold text-4xl">
        <h1>حسابــــي</h1>
        <button
          type="button"
          className="absolute top-1/2 right-4 transform h-full  -translate-y-1/2"
          onClick={() => (setOpen(!open), setPage(""))}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-8 h-9"
            aria-hidden="true"
            fill="#23AA49"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ y: -50, opacity: 0 }}
            exit={{ y: -150, opacity: 0, transition: { duration: 0.1 } }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.2 }}
          >
            {page === "" && (
              <div className="grid grid-cols-2 gap-4 px-4 mt-14" dir="rtl">
                {elements.map((e, i) => (
                  <div
                    key={i}
                    className="bg-primary text-white flex flex-col justify-evenly rounded-2xl items-center h-[214px] p-3"
                    onClick={() => {
                      handleClick(e);
                    }}
                  >
                    <p>{e.icon}</p>
                    <p className="font-bold">{e.title}</p>
                    <p className="text-xs text-center">{e.desc}</p>
                  </div>
                ))}
              </div>
            )}
            {page === "settings" && (
              <motion.div
                initial={{ y: -50, opacity: 0 }}
                exit={{ y: -150, opacity: 0, transition: { duration: 0.1 } }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.2 }}
                className="flex flex-col my-14 p-1"
              >
                <NavLink
                  to="change-phonenumber"
                  onClick={() => setOpen(false)}
                  className="font-bold text-end border-b py-4 px-6"
                >
                  <div className="flex justify-between ">
                    <p>{left_arrow}</p>
                    <p>تغيير رقم الهاتف</p>
                  </div>
                </NavLink>
                <NavLink
                  to="change-password"
                  onClick={() => setOpen(false)}
                  className="font-bold text-end border-b py-4 px-6"
                >
                  <div className="flex justify-between ">
                    <p>{left_arrow}</p>
                    <p>تغيير كلمة المرور</p>
                  </div>
                </NavLink>
                <NavLink
                  to="update-info"
                  onClick={() => setOpen(false)}
                  className="font-bold text-end border-b py-4 px-6"
                >
                  <div className="flex justify-between ">
                    <p>{left_arrow}</p>
                    <p> تحديث معلومات الحساب</p>
                  </div>
                </NavLink>
              </motion.div>
            )}
            {page === "inputs" && (
              <motion.div
                initial={{ y: -50, opacity: 0 }}
                exit={{ y: -150, opacity: 0, transition: { duration: 0.1 } }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.2 }}
                className="flex flex-col my-14 p-1"
              >
                <NavLink
                  to="crops"
                  onClick={() => setOpen(false)}
                  className="font-bold text-end border-b py-4 px-6"
                >
                  <div className="flex justify-between ">
                    <p>{left_arrow}</p>
                    <p>المحاصيل</p>
                  </div>
                </NavLink>
                <NavLink
                  to="services"
                  onClick={() => setOpen(false)}
                  className="font-bold text-end border-b py-4 px-6"
                >
                  <div className="flex justify-between ">
                    <p>{left_arrow}</p>
                    <p>الخدمات</p>
                  </div>
                </NavLink>
                <NavLink
                  to="inputs"
                  onClick={() => setOpen(false)}
                  className="font-bold text-end border-b py-4 px-6"
                >
                  <div className="flex justify-between ">
                    <p>{left_arrow}</p>
                    <p>مدخلات الإنتاج</p>
                  </div>
                </NavLink>
                <NavLink
                  to="auctions"
                  onClick={() => setOpen(false)}
                  className="font-bold text-end border-b py-4 px-6"
                >
                  <div className="flex justify-between ">
                    <p>{left_arrow}</p>
                    <p>المزادات</p>
                  </div>
                </NavLink>
              </motion.div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default MobileNav;
